package one.healthium.ricediet.presentation.navigation.main

import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.webhistory.WebNavigationOwner
import com.arkivanov.decompose.value.Value
import com.arkivanov.essenty.backhandler.BackHandlerOwner
import one.healthium.content.navigation.content.ContentComponent
import one.healthium.content.navigation.media.VideoPlayerComponent
import one.healthium.content.navigation.shopping_list.ShoppingListComponent
import one.healthium.decompose.ModalStack
import one.healthium.decompose.ModalT
import one.healthium.health_log.navigation.HealthLogComponent
import one.healthium.log_food.ui.navigation.LogFoodComponent
import one.healthium.log_food.ui.scanner.navigation.BarcodeScannerComponent
import one.healthium.meal_plans.tutorial.navigation.PersonalMealPlanTutorialComponent
import one.healthium.profile.navigation.log_water.LogWaterComponent
import one.healthium.profile.navigation.log_weight.LogWeightComponent
import one.healthium.profile.navigation.update_age.UpdateAgeComponent
import one.healthium.profile.navigation.update_food.UpdateFoodComponent
import one.healthium.profile.navigation.update_height.UpdateHeightComponent
import one.healthium.profile.navigation.update_initial_weight.UpdateInitialWeightComponent
import one.healthium.profile.navigation.update_name.UpdateNameComponent
import one.healthium.profile.navigation.update_weight.UpdateWeightComponent
import one.healthium.ricediet.presentation.navigation.home.HomeComponent
import one.healthium.tutorial.domain.TutorialModel
import one.healthium.tutorial.navigation.TutorialComponent
import one.healthium.log_food.ui.camera.FoodCameraComponent
import one.healthium.update_food_preferences.navigation.UpdateFoodPreferencesComponent
import one.primehealth.app.DeepLink

interface MainComponent : BackHandlerOwner, WebNavigationOwner {
    val stack: Value<ChildStack<*, Child>>
    val stackModal: Value<ModalStack<*, ModalT<SlotChild>>>

    fun onBackClicked()
    fun onDismissModal(config: Any)
    fun onDeepLink(deepLink: DeepLink)
    fun onShowTutorial(model: TutorialModel)

    sealed class Child {
        class Home(val component: HomeComponent) : Child()
        class Content(val component: ContentComponent) : Child()
        class Video(val component: VideoPlayerComponent) : Child()
        class ShoppingList(val component: ShoppingListComponent) : Child()
    }

    sealed class SlotChild {
        class LogFood(val component: LogFoodComponent) : SlotChild()
        class LogWater(val component: LogWaterComponent) : SlotChild()
        class LogWeight(val component: LogWeightComponent) : SlotChild()
        class LogSymptoms(val component: HealthLogComponent) : SlotChild()
        class UpdateWeight(val component: UpdateWeightComponent) : SlotChild()
        class UpdateFood(val component: UpdateFoodComponent) : SlotChild()
        class Tutorial(val component: TutorialComponent) : SlotChild()
        class UpdateName(val component: UpdateNameComponent) : SlotChild()
        class UpdateAge(val component: UpdateAgeComponent) : SlotChild()
        class UpdateHeight(val component: UpdateHeightComponent) : SlotChild()
        class UpdateInitialWeight(val component: UpdateInitialWeightComponent) : SlotChild()
        class BarcodeScanner(val component: BarcodeScannerComponent) : SlotChild()
        class UpdateFoodPreferences(val component: UpdateFoodPreferencesComponent) : SlotChild()
        class PersonalMealPlanTutorial(val component: PersonalMealPlanTutorialComponent) : SlotChild()
        class FoodCamera(val component: FoodCameraComponent) : SlotChild()
    }
}